import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  SaleSettingsFirestoreResponse,
  CreateSaleSettingsDto,
  UpdateSaleSettingsDto,
  DeleteSaleSettingsResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const SaleSettingsResponseSchema = SaleSettingsFirestoreResponse;
export const CreateSaleSettingsSchema = CreateSaleSettingsDto;
export const UpdateSaleSettingsSchema = UpdateSaleSettingsDto;
export const DeleteResponseSchema = DeleteSaleSettingsResponseDto;

// Type exports
export type SaleSettingsResponse = z.infer<typeof SaleSettingsFirestoreResponse>;
export type CreateSaleSettings = z.infer<typeof CreateSaleSettingsDto>;
export type UpdateSaleSettings = z.infer<typeof UpdateSaleSettingsDto>;

// API factory function
export function createSaleSettingsApi(client: TypedApiClient) {
  return {
    getSaleSettings: (): Promise<SaleSettingsResponse[]> => {
      return client.get('/sale-settings', {
        responseSchema: z.array(SaleSettingsResponseSchema),
      });
    },

    getSaleSettingsById: (id: string): Promise<SaleSettingsResponse> => {
      return client.get(apiPath`/sale-settings/${id}`, {
        responseSchema: SaleSettingsResponseSchema,
      });
    },

    createSaleSettings: (data: CreateSaleSettings): Promise<SaleSettingsResponse> => {
      CreateSaleSettingsSchema.parse(data);
      return client.post('/sale-settings', {
        data,
        responseSchema: SaleSettingsResponseSchema,
      });
    },

    updateSaleSettings: (id: string, data: UpdateSaleSettings): Promise<SaleSettingsResponse> => {
      return client.patch(apiPath`/sale-settings/${id}`, {
        data,
        responseSchema: SaleSettingsResponseSchema,
      });
    },

    deleteSaleSettings: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/sale-settings/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
